import React from "react";
import styled from "styled-components";
import cartImage from "../../../assets/images/image/clothes/product-1.png";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";
import UnderlineButton from "../../buttons/UnderlineButton";

const Wrapper = styled.div``;

const Container = styled.div`
  display: flex;
  color: black;
  position: relative;
  font-size: 14px;
  padding: 14px 0;
  justify-content: space-between;
  border-bottom: solid 0.4px ${colors.line};
`;

const Left = styled.div`
  display: flex;
  gap: 12px;
`;

const Image = styled.div``;

const Price = styled.div`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  height: fit-content;
  font-size: ${fontSize.s};
  color: ${colors.maroon};
  span {
    font-size: ${fontSize.xs};
  }
`;

const Details = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Name = styled.span`
  font-size: ${fontSize.xs};
  text-transform: uppercase;
`;

const Color = styled.span`
  font-size: ${fontSize.xxs};
`;

const Size = styled.span`
  font-size: ${fontSize.xxs};
`;
const Quantity = styled.span`
  font-size: ${fontSize.xxs};
`;

const Links = styled.div`
  margin-top: auto;
  display: flex;
  gap: 8px;
`;

const Link = styled.span`
  cursor: pointer;
  position: relative;
  letter-spacing: 0.08rem;
  width: fit-content;
  font-size: ${fontSize.xxs};
  color: ${colors.border};
  transition: all 0.2s ease-in;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 100%;
    height: 1px;
    background-color: white;
    transform: translateX(-50%) scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }

  &:hover {
    color: black;

    &::after {
      transform: translateX(-50%) scaleX(1);
      background-color: black;
    }
  }
`;

function CartItem({ onEdit }) {
  return (
    <Wrapper>
      <Container>
        <Left>
          <Image>
            <img src={cartImage} height="100px" alt="" />
          </Image>

          <Details>
            <Name>Two tone dress</Name>
            <Color>Cream White Black</Color>
            <Row>
              <Size>Size: 42</Size>
              <Quantity>Qty: 1</Quantity>
            </Row>
            <Links>
             <Link onClick={onEdit}>Edit</Link>
              <Link
                onClick={() => {
                  alert("removed");
                }}
              >
                Remove
              </Link>
            </Links>
          </Details>
        </Left>
        <Price>
          <span>USD</span>4000
        </Price>
      </Container>
    </Wrapper>
  );
}

export default CartItem;
